import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .use(ICU)
  .init({
    ns: ['translation', 'zapper'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ptbr'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
